<template>
  <div id="restrictionsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="restrictionSearch"
          :label="$t('general.search')"
          clearable
          append-outer-icon="search">
        </v-text-field>
          <v-dialog persistent v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                <v-icon left>add</v-icon>
                {{ $t('restriction.add') }}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid"
                  >
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          class="mr-3"
                          clearable
                          required
                          :rules="rules.textRules"
                          :label="$t('general.name')"
                          :error-messages="errors.name"
                          v-model="editedItem.name"
                          @keyup.enter="save"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="userLogged.roles[0].id !== undefined && userLogged.roles[0].id === 1">
                        <v-select
                          required
                          :items="companies"
                          item-value="id"
                          item-text="name"
                          :rules="rules.required"
                          :label="$t('company.name')"
                          :error-messages="errors.company_id"
                          v-model="editedItem.company_id"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs3 class="text-sm-left" v-if="restrictionValue !== 7">
                        <b-form-group class="my-0" :label="$t('restriction.restrictionBy') + ':'">
                          <b-form-radio-group
                            button-variant="outline-primary"
                            id="btn-radios-1"
                            v-model="restrictionSelect"
                            :options="restrictionOptions"
                            buttons
                            name="radios-btn-default"
                          ></b-form-radio-group>
                        </b-form-group>
                      </v-flex>
                      <v-flex xs9 v-if="restrictionSelect === 1 && restrictionValue !== 7">
                        <v-select
                          :multiple="editedIndex === -1"
                          chips
                          required
                          :items="areasFilter"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :rules="rules.required"
                          :label="$t('general.areas')"
                          :error-messages="errors.gst_areas_id"
                          v-model="editedItem.areas"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs9 v-if="restrictionSelect === 2 && restrictionValue !== 7">
                        <v-select
                          :multiple="editedIndex === -1"
                          chips
                          required
                          :items="projects"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :rules="rules.required"
                          :label="$t('general.projects')"
                          :error-messages="errors.core_project_id"
                          v-model="editedItem.projects"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs3 v-if="editedIndex === -1 && restrictionValue !== 7">
                        <v-switch 
                          color="primary"
                          v-model="switchAllCategories"
                          :label="switchAllCategories ? $t('expenseDetailEmployee.allCategories') : $t('expenseDetailEmployee.perCategorie')"
                        ></v-switch>
                      </v-flex>
                      <v-flex :class="editedIndex === -1 ? 'xs9' : 'xs12'" v-if="restrictionValue !== 7">
                        <v-select v-if="!switchAllCategories"
                          required
                          :items="categories"
                          item-value="id"
                          item-text="name"
                          class="mr-3"
                          :rules="rules.required"
                          :label="$t('categories.name')"
                          :error-messages="errors.gst_category_id"
                          v-model="editedItem.gst_category_id"
                          :multiple="editedIndex === -1">
                        </v-select>
                      </v-flex>
                      <v-flex xs6>
                        <v-select
                          required
                          :disabled="restrictionValue === 7"
                          :items="restrictionTypesFilter"
                          item-value="id"
                          item-text="name"
                          :rules="rules.required"
                          class="mr-3"
                          :label="$t('restriction.type')"
                          :error-messages="errors.gst_restrictions_type_id"
                          v-model="restrictionValue"
                        >
                        <template slot="selection" slot-scope="data">
                            {{ $t('restriction.' + data.item.name)}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ $t('restriction.' + data.item.name)}}
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 2">
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              clearable
                              v-model="editedItem.value"
                              :label="$t('restriction.date')"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                          :locale="$t('general.locale')"
                          v-model="editedItem.value"
                          @input="menu = false"></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 3">
                        <v-select
                          required
                          :items="paymentType"
                          item-value="id"
                          item-text="descripcion"
                          :rules="rules.required"
                          class="mr-3"
                          :label="$t('general.formaPago')"
                          v-model="editedItem.value"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 3">
                        <v-text-field
                          clearable
                          required
                          mask="###################"
                          :disabled="!editedItem.amountMaxCheck"
                          prepend-icon="attach_money"
                          :rules="rules.required"
                          :label="$t('general.amountMax')"
                          :error-messages="errors.value"
                          v-model="editedItem.amountMax">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 3">
                        <v-switch
                          color="primary"
                          @change="onStatusChange"
                          v-model="editedItem.amountMaxCheck"
                          :label="editedItem.amountMaxCheck ? $t('general.active') : $t('general.inactive')"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 4">
                        <v-autocomplete
                          required
                          :items="currency"
                          item-value="id"
                          item-text="descripcion"
                          :filter="filterCurrency"
                          :rules="rules.required"
                          class="mr-3"
                          :label="$t('general.currency')"
                          v-model="editedItem.value"
                        >
                        <template slot="selection" slot-scope="data">
                          {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                        </template>
                        <template slot="item" slot-scope="data">
                          {{ data.item.c_Moneda }} - {{ data.item.descripcion }}
                        </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 1 || restrictionValue === 5">
                        <v-text-field
                          clearable
                          required
                          mask="###################"
                          prepend-icon="attach_money"
                          :rules="rules.required"
                          :label="$t('setting.value')"
                          :error-messages="errors.value"
                          v-model="editedItem.value"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs6 v-if="restrictionValue === 6">
                        <h3>{{$t('restriction.requiredFile')}}:</h3>
                        <v-radio-group
                          v-model="editedItem.value"
                          :rules="rules.yesNoOption"
                          :error-messages="errors.value"
                          row
                        >
                          <v-radio color="primary" :value="1" :label="$t('general.yes')"/>
                          <v-radio color="primary" :value="0" :label="$t('general.no')"/>
                        </v-radio-group>
                      </v-flex>
                      <v-flex xs12 v-if="restrictionValue === 7">
                        <v-layout row wrap align-center>
                          <v-flex xs8>
                            <v-text-field
                              clearable
                              class="mr-3"
                              :label="editingKeyword === -1 ? $t('keywords.addOne') : $t('keywords.edit')"
                              :error-messages="errors.param3"
                              v-model="keywordDraft"
                              @keyup.enter="saveKeyword"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs4 class="text-sm-right">
                            <v-btn
                              small
                              round
                              flat
                              color="primary darken-1"
                              v-if="editingKeyword !== -1"
                              @click="cancelKeyword"
                            >
                              {{ $t('general.cancel') }}
                            </v-btn>
                            <v-btn
                              small
                              round
                              depressed
                              color="primary"
                              :disabled="!keywordDraft"
                              @click="saveKeyword"
                            >
                              <v-icon left small>{{ editingKeyword === -1 ? 'add' : 'check' }}</v-icon>
                              {{ editingKeyword === -1 ? $t('general.add') : $t('general.save') }}
                            </v-btn>
                          </v-flex>
                          <v-flex xs12 class="keywords-editor">
                            <v-chip
                              v-for="(keyword, index) in editedItem.param3"
                              :key="index"
                              small
                              close
                              :color="editingKeyword === index ? 'primary' : ''"
                              :text-color="editingKeyword === index ? 'white' : ''"
                              @input="removeKeyword(index)"
                            >
                              <span class="keyword-chip" @click="editKeyword(index)">{{ keyword }}</span>
                            </v-chip>
                            <span class="grey--text" v-if="!editedItem.param3 || !editedItem.param3.length">
                              {{ $t('keywords.empty') }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <!-- <v-checkbox
                      required
                      :label="$t('restriction.warningQuestion')"
                      color="primary"
                      :value="1"
                      v-model="editedItem.is_warning"
                      :error-messages="errors.is_warning"
                    >
                    </v-checkbox> -->
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="close" color="primary darken-1" round flat>
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn @click="save" :loading="loading" :disabled="loading" color="primary" round depressed>
                  {{ $t('general.submit') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-layout>
      <v-data-table
        :search="restrictionSearch"
        class="elevation-2"
        :headers="headers"
        :items="filterRestrictions"
        :loading="loadingItems"
        :rows-per-page-items="[10,15,25]"
        :pagination.sync="pagination">
      <template v-slot:headers="props">
        <tr class="bg-heavy-rain">
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
            >
            <h2 class="font-weight-black primary--text mb-0">
              <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
              {{ header.text }}
            </h2>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td width="60px">{{props.item.id}}</td>
          <td class="text-sm-center">
            <v-chip
              class="font-weight-black"
              v-if="restrictionType(props.item).type === 1"
              color="primary"
              dark
              small
            ><v-avatar class="primary lighten-2">A:</v-avatar>{{restrictionType(props.item).name}}</v-chip>
            <v-chip
              class="font-weight-black"
              v-if="restrictionType(props.item).type === 2"
              color="info"
              dark
              small
            ><v-avatar class="info darken-2">P:</v-avatar>{{restrictionType(props.item).name}}</v-chip>
            <v-chip
              class="font-weight-black"
              v-if="restrictionType(props.item).type === 3"
              color="grey darken-1"
              dark
              small
            >{{restrictionType(props.item).name}}</v-chip>
          </td>
          <td class="text-sm-center font-weight-bold">"{{props.item.name}}"</td>
          <td class="text-sm-center">{{ categoryName(props.item) }}</td>
          <td class="text-sm-center">{{$t('restriction.' + props.item.restriction_type.name)}}</td>
          <td class="text-sm-center">
            <template v-if="props.item.restriction_type.id === 1 || props.item.restriction_type.id === 5 || props.item.restriction_type.id === 2">{{props.item.value}}</template>
            <template v-else-if="props.item.restriction_type.id === 3">"{{paymentFilter(props.item.value)}}"</template>
            <template v-else-if="props.item.restriction_type.id === 4">"{{currencyFilter(props.item.value)}}"</template>
            <v-chip small v-else-if="props.item.restriction_type.id === 6">
              {{$t('restriction.requiredFile')}}?:&nbsp;<span class="font-weight-black">{{props.item.value == 1 ? $t('general.yes') : $t('general.no')}}</span>
            </v-chip>
            <v-menu open-on-hover offset-y v-else-if="props.item.restriction_type.id === 7">
              <template v-slot:activator="{ on }">
                <v-chip small v-on="on">
                  <span class="font-weight-black">{{keywords(props.item).length}}</span>&nbsp;{{$t('general.keywords').toLowerCase()}}
                </v-chip>
              </template>
              <v-card>
                <v-card-text class="keywords-list">
                  <v-chip
                    small
                    v-for="(keyword, index) in keywords(props.item)"
                    :key="index"
                  >{{keyword}}</v-chip>
                </v-card-text>
              </v-card>
            </v-menu>
            <template v-else>- -</template>
          </td>
          <td class="text-sm-center" v-if="$store.state.userLogged.roles[0].id === 1">{{props.item.company.name}}</td>
          <td class="text-sm-center">
            <v-layout row :class="props.item.restriction_type.id === 7 ? 'justify-center' : ''">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    outline
                    icon
                    color="info"
                    v-on="on"
                    @click="editItem(props.item)"
                  >
                    <v-icon small>edit</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.edit') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="props.item.restriction_type.id !== 7">
                <template v-slot:activator="{ on }">
                  <v-btn
                  small
                  outline
                  icon
                  color="error"
                  v-on="on"
                  @click="removed(props.item)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
                </template>
                <span>{{ $t('general.delete') }}</span>
              </v-tooltip>
            </v-layout>
          </td>
        </tr>
      </template>
      </v-data-table>
      <v-dialog persistent v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat >
            <h2 class="font-weight-black error--text mb-0">{{ $t('restriction.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('general.name') }}: </span>{{removedItem.name}}</p>
            <p class="font-weight-black" v-if="removedItem.area || removedItem.project">
              <span class="error--text">
                {{ removedItem.area ? $t('area.name') : $t('general.project') }}:
              </span>
              {{removedItem.area ? removedItem.area.name : removedItem.project.name}}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="removeItem(removedItem)"
            >
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'restrictionsComponent',
  data () {
    return {
      restrictionSearch: '',
      restrictionSelect: 1,
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      dialog: false,
      removeDialog: false,
      valid: true,
      menu: false,
      userLogged: {
        roles: [
          {
            id: ''
          }
        ],
        company: [
          {
            id: ''
          }
        ]
      },
      editedIndex: -1,
      keywordDraft: '',
      editingKeyword: -1,
      removedItem: {},
      originalItem: {},
      editedItem: {
        id: 0,
        name: '',
        company_id: '',
        areas: null,
        value: null,
        gst_restrictions_type_id: '',
        projects: null,
        gst_category_id: '',
        is_warning: 0,
        amountMaxCheck: true,
        amountMax: null,
        param3: []
      },
      defaultItem: {
        id: 0,
        name: '',
        company_id: '',
        areas: null,
        value: null,
        gst_restrictions_type_id: '',
        projects: null,
        gst_category_id: '',
        is_warning: 0,
        amountMaxCheck: true,
        amountMax: null,
        param3: []
      },
      areas: [],
      projects: [],
      companies: [],
      categories: [],
      restriction_types: [],
      restrictionValue: null,
      restrictions: [],
      paymentType: [],
      currency: [],
      currencyItem: '',
      errors: {},
      loading: false,
      loadingItems: true,
      switchAllCategories: false
    }
  },
  computed: {
    heading () {
      return this.$t('general.restrictions')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-user-lock fa-fw icon-color'
    },
    headers () {
      if (this.userLogged.roles[0].id === 2) {
        return [
          {
            text: '#',
            align: 'center',
            value: 'id',
            sortable: true
          },
          {
            text: this.$t('area.name') + '/' + this.$t('general.project'),
            align: 'center',
            value: 'restriction_type.name',
            sortable: true
          },
          {
            text: this.$t('general.name'),
            align: 'center',
            value: 'name',
            sortable: true
          },
          {
            text: this.$t('categories.name'),
            align: 'center',
            value: 'category.name',
            sortable: true
          },
          {
            text: this.$t('restriction.type'),
            align: 'center',
            value: 'restriction_type.name',
            sortable: true
          },
          {
            text: this.$t('setting.value'),
            align: 'center',
            value: 'value',
            sortable: true
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            sortable: false
          }
        ]
      } else if (this.userLogged.roles[0].id === 1) {
        return [
          {
            text: '#',
            align: 'center',
            value: 'id',
            sortable: true
          },
          {
            text: this.$t('area.name') + '/' + this.$t('general.project'),
            align: 'center',
            value: 'restriction_type.name',
            sortable: true
          },
          {
            text: this.$t('general.name'),
            align: 'center',
            value: 'name',
            sortable: true
          },
          {
            text: this.$t('categories.name'),
            align: 'center',
            value: 'category.name',
            sortable: true
          },
          {
            text: this.$t('restriction.type'),
            align: 'center',
            value: 'restriction_type.name',
            sortable: true
          },
          {
            text: this.$t('setting.value'),
            align: 'center',
            value: 'value',
            sortable: true
          },
          {
            text: this.$t('branch.company'),
            align: 'center',
            value: 'company.name',
            sortable: true
          },
          {
            text: this.$t('general.actions'),
            align: 'center',
            sortable: false
          }
        ]
      }
    },
    restrictionOptions () {
      return [
        {text: this.$t('area.name'), value: 1},
        {text: this.$t('general.project'), value: 2}
      ]
    },
    rules () {
      return this.$validationRules()
    },
    filterRestrictions () {
      if (this.userLogged.roles[0].id === 1) {
        return this.restrictions
      } else {
        return this.restrictions.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    restrictionTypesFilter () {
      if (this.restrictionValue === 7) return this.restriction_types
      return this.restriction_types.filter(item => item.id !== 7)
    },
    areasFilter () {
      if (this.userLogged.roles[0].id === 1) {
        return this.areas.filter(item => item.company_id === this.editedItem.company_id)
      } else if (this.userLogged.roles[0].id === 2) {
        return this.areas.filter(item => item.company_id === this.userLogged.company[0].id)
      }
    },
    // userLogged () {
    //   return this.$store.state.userLogged
    // },
    formTitle () { // watch the dialog title
      return this.editedIndex === -1 ? this.$t('restriction.add') : this.$t('restriction.edit')
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    companies () {
      if (this.userLogged.roles[0].id === 2) {
        this.editedItem.company_id = this.userLogged.company[0].id
      }
    },
    // 'editedItem.company_id' () {
    //   this.editedItem.gst_area_id = null
    // },
    restrictionValue () {
      if (this.editedIndex === -1) {
        this.editedItem.value = null
      } else if (this.restrictionValue === 2) {
        this.editedItem.value = null
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    },
    userLogged () {
      this.$emit('get', {context: this, id: this.$store.state.userLogged.company[0].id})
    },
    restrictionSelect () {
      if (this.restrictionSelect === 1) {
        this.editedItem.projects = null
      } else if (this.restrictionSelect === 2) {
        this.editedItem.areas = null
      } else {
        this.editedItem.projects = null
        this.editedItem.areas = null
      }
    },
    editedIndex () {
      if (this.editedIndex !== -1) {
        if (this.editedItem.gst_area_id) {
          this.restrictionSelect = 1
        } else if (this.editedItem.core_project_id) {
          this.restrictionSelect = 2
        }
      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    onStatusChange () {
      if (!this.editedItem.amountMaxCheck) this.editedItem.amountMax = 0
    },
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    currencyFilter (id) {
      if (this.currency.length >= 1) {
        let result = this.currency.find(item => item.id === parseInt(id))
        return result.c_Moneda + ' - ' + result.descripcion
      }
    },
    filterCurrency (item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
    },
    paymentFilter (id) {
      if (this.paymentType.length >= 1) {
        let result = this.paymentType.find(item => item.id === parseInt(id))
        return result.descripcion
      }
    },
    keywords (item) {
      return Array.isArray(item.param3) ? item.param3 : []
    },
    editKeyword (index) { // load the keyword in to the input to rename it
      this.editingKeyword = index
      this.keywordDraft = this.editedItem.param3[index]
      this.$set(this.errors, 'param3', [])
    },
    cancelKeyword () { // leave the edition mode and clean the input
      this.editingKeyword = -1
      this.keywordDraft = ''
    },
    saveKeyword () { // add the new keyword or replace the one that is being edited
      let keyword = this.keywordDraft ? this.keywordDraft.trim() : ''
      if (!keyword) return
      let keywords = this.editedItem.param3 || []
      let duplicated = keywords.some((item, index) => {
        return index !== this.editingKeyword && item.toLowerCase() === keyword.toLowerCase()
      })
      if (duplicated) {
        this.$set(this.errors, 'param3', [this.$t('keywords.exists')])
        return
      }
      if (this.editingKeyword === -1) {
        keywords.push(keyword)
      } else {
        keywords.splice(this.editingKeyword, 1, keyword)
      }
      this.$set(this.editedItem, 'param3', keywords)
      this.$set(this.errors, 'param3', [])
      this.cancelKeyword()
    },
    removeKeyword (index) { // drop the keyword from the list
      this.editedItem.param3.splice(index, 1)
      if (this.editingKeyword === index) this.cancelKeyword()
      else if (this.editingKeyword > index) this.editingKeyword--
    },
    categoryName (item) {
      if (item.gst_restrictions_type_id === 7) return this.$t('general.alls')
      return item.category ? item.category.name : '- -'
    },
    restrictionType (item) {
      if (item.gst_area_id) {
        return {
          type: 1,
          name: item.area.name
        }
      } else if (item.core_project_id) {
        return {
          type: 2,
          name: item.project.name
        }
      } else if (item.gst_restrictions_type_id === 7) {
        return {
          type: 3,
          name: this.$t('general.alls')
        }
      } else {
        return {
          type: 1,
          name: '- -'
        }
      }
    },
    removed (item) { // set the item that want to remove and open the dialog
      this.removedItem = item
      this.removeDialog = true
    },
    removeItem (item) { // change the status of the users to '0'
      const index = this.companies.indexOf(item)
      this.loading = true
      this.delete(item, index)
    },
    close () { // close the dialog and re-assing default values
      this.dialog = false
      this.loading = false
      this.removeDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem.param3 = []
      this.errors = {}
      this.cancelKeyword()
      this.restrictionValue = null
      this.editedIndex = -1
      this.switchAllCategories = false
      this.$refs.form.resetValidation()
    },
    editItem (item) { // show the element that want to edit
      this.editedIndex = this.restrictions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editedItem.areas = item.gst_area_id
      this.editedItem.projects = item.core_project_id
      this.originalItem = Object.assign({}, item)
      this.originalItem.areas = item.gst_area_id
      this.originalItem.projects = item.core_project_id
      this.editedItem.param3 = Array.isArray(item.param3) ? item.param3.slice() : []
      if (item.gst_restrictions_type_id !== 7) this.editedItem.value = parseInt(this.editedItem.value)
      this.restrictionValue = this.editedItem.gst_restrictions_type_id
      if (this.editedItem.gst_restrictions_type_id === 3) {
        this.editedItem.amountMaxCheck = this.editedItem.param1 > 0 ? true : false
        this.editedItem.amountMax = this.editedItem.param1
      }
      
      this.dialog = true
    },
    save () { // evaluate the form and save de values
      if (this.$refs.form.validate()) {
        if (this.restrictionValue === 7 && !this.keywords(this.editedItem).length) {
          this.$set(this.errors, 'param3', [this.$t('validation.required')])
          return
        }
        this.loading = true
        this.disabled = true
        this.editedItem.gst_restrictions_type_id = this.restrictionValue

        if (this.userLogged.roles[0].id !== 1) this.editedItem.company_id = this.userLogged.company[0].id        

        if (this.editedIndex > -1) { this.put() } 
        else {
          if(this.switchAllCategories) this.editedItem.gst_category_id = this.categories.map(item => item.id)
          this.post()
        }
      }
    },
    initialize () { // Getting the elements for companies and the regimen library
      this.getLogged()
    },
    post () { // method to post an element in to de DB
      this.$emit('restrictions_post', {item: this.editedItem, context: this})
    },
    put () { // method to edit an element in the DB
      this.$emit('restrictions_put', {item: this.editedItem, index: this.editedIndex, context: this})
    },
    delete (item, index) { // method to remove an element from de DB
      this.$emit('restrictions_delete', {item: item, index: index, context: this})
    },
    refresh () {
      this.loadingItems = true
      this.$emit('refresh', {context: this, id: this.$store.state.userLogged.company[0].id})
    }
  }
}
</script>
<style scoped>
.keyword-chip {
  cursor: pointer;
}
.keywords-editor {
  max-height: 220px;
  overflow-y: auto;
}
.keywords-list {
  max-width: 420px;
  max-height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/restrictions.component.vue